import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import BrandLogo from '../common/BrandLogo';

const GuestHeader: React.FC = () => {
  const location = useLocation();
  const isAuthPage = ['/login', '/register'].includes(location.pathname);
  const isStandalonePage = location.pathname.startsWith('/invoice/') || location.pathname.startsWith('/gallery/') || location.pathname.startsWith('/crm/contract/');

  if (isAuthPage || isStandalonePage) return null;

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
        <Link to="/home">
          <BrandLogo iconSize="w-8 h-8" textSize="text-xl" />
        </Link>
        <div className="flex items-center space-x-3 sm:space-x-4">
          <Link 
            to="/explore"
            className={`hidden sm:block text-sm font-medium transition-colors ${
              location.pathname.startsWith('/explore') ? 'text-black' : 'text-gray-600 hover:text-black'
            }`}
          >
            Explore
          </Link>
          <Link 
            to="/opportunities"
            className={`hidden sm:block text-sm font-medium transition-colors ${
              location.pathname.startsWith('/opportunities') ? 'text-black' : 'text-gray-600 hover:text-black'
            }`}
          >
            Opportunities
          </Link>
          <Link 
            to="/login"
            className="text-sm font-medium text-gray-600 hover:text-black transition-colors"
          >
            Login
          </Link>
          <Link 
            to="/register"
            className="text-sm font-medium bg-black text-white px-4 py-2 rounded-full hover:bg-gray-800 transition-all"
          >
            Sign Up
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default GuestHeader;
